import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const basketApi = createApi({
	reducerPath: 'basketApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({

		// POST — Добавить item в корзину
		addItemToBasket: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/add',
				method: 'POST',
				body: data,
				schema,
				prefix: 'basket',
			}),
		}),

		// GET — Получить корзину по userId
		getUserBasket: builder.query({
			query: ({ userId, schema }) => ({
				url: `/${userId}`,
				method: 'GET',
				schema,
				prefix: 'basket',
			}),
		}),

		// POST — Удалить item из корзины
		deleteItemFromBasket: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/remove',
				method: 'POST',
				body: data,
				schema,
				prefix: 'basket',
			}),
		}),

		// PUT — Уменьшить количество item в корзине
		decrementItemFromBasket: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/decrement',
				method: 'PUT',
				body: data,
				schema,
				prefix: 'basket',
			}),
		}),
	}),
});

export const {
	useAddItemToBasketMutation,
	useGetUserBasketQuery,
	useLazyGetUserBasketQuery,
	useDeleteItemFromBasketMutation,
	useDecrementItemFromBasketMutation,
} = basketApi;
